import { useMutation, useQuery } from '@apollo/client/react'
import { DISMISS_OBJECT, QUERY_ACCOUNT } from '../graphql/account'
import { useCallback } from 'react'

type UseDismissObjectReturn = {
  onDismissObject: () => void
}

const useDismissObject = ({
  organizationId,
  dismissedObject,
}: {
  organizationId?: string
  dismissedObject: { id: string; expiresAt?: string }
}): UseDismissObjectReturn => {
  const { data } = useQuery(QUERY_ACCOUNT, { fetchPolicy: 'cache-only' })
  const [dismissObject] = useMutation(DISMISS_OBJECT)

  const onDismissObject = useCallback(() => {
    if (!dismissedObject || !organizationId) {
      return
    }

    dismissObject({
      variables: { organizationId, dismissedObject },
      update: (cache) => {
        const existing = data?.account?.currentOrganization
        if (!existing) return

        cache.modify({
          id: cache.identify(existing),
          fields: {
            dismissedObjects(existingObjects = []) {
              return [
                ...existingObjects,
                { __typename: 'DismissedObject', id: dismissedObject.id },
              ]
            },
          },
        })
      },
    })
  }, [dismissedObject, organizationId, dismissObject, data])

  return { onDismissObject }
}

export default useDismissObject
